export const buyerGuideContent = {
  title: 'The Mahj Market Buyer Guide',
  metaTitle: 'Buyer Guide | The Mahj Market',
  metaDescription:
    'A practical buyer guide for The Mahj Market covering shopping, secure checkout, shipping updates, returns, and verified disputes.',
  sections: [
    {
      heading: 'Welcome to The Mahj Market',
      paragraphs: [
        'Welcome to The Mahj Market, a curated destination for distinctive Mahjong finds from trusted independent sellers.',
      ],
    },
    {
      heading: 'Shop the Collection',
      paragraphs: [
        'Explore a unique mix of Mahjong sets, tiles, and accessories - many pieces are limited or one-of-a-kind, so favorites go quickly.',
      ],
    },
    {
      heading: 'Seamless Purchasing',
      listItems: [
        'Secure checkout through Stripe. Stripe charges a 3% credit card processing fee, which will be added to your purchase price. The Mahj Market does not benefit from this fee.',
        'All sellers go through an onboarding process that ensures they are reputable sellers, reducing the risk of products not shipping or money loss.',
        'Direct access to seller listings and details.',
        'Messaging available for pre-purchase questions.',
        'Money is never released until the product is received and accepted.',
      ],
    },
    {
      heading: 'Shipping & Updates',
      paragraphs: [
        'All orders ship through Shippo with tracking provided.',
        'You will receive email updates when your item is purchased, shipped, and delivered.',
      ],
    },
    {
      heading: 'Returns',
      paragraphs: [
        'All sales are final. Returns are only accepted in the case of a verified dispute.',
      ],
    },
    {
      heading: 'The Experience',
      paragraphs: [
        'Every purchase supports a community of Mahjong enthusiasts and collectors - bringing elevated style to the table.',
      ],
    },
  ],
};

export default buyerGuideContent;
